(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["marwona-bware"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('marwona-bware')) {
    customElements.define('marwona-bware', class extends HTMLElement {
      connectedCallback() {
        this.onVariantChange = (event) => {
          const owner = event.target.closest?.('product-info');
          if (!owner || owner.dataset.productId !== this.dataset.productId || !owner.contains(this)) return;
          const variant = event.detail?.variant;
          this.querySelector('details').open = /b-ware|b-optik/i.test(variant?.title || '');
        };
        document.addEventListener('variant:change', this.onVariantChange, true);
      }
      disconnectedCallback() {
        document.removeEventListener('variant:change', this.onVariantChange, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
